import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { from, map } from 'rxjs';
import { FaqService } from '../../../services/faq/faq.service';

export const setupFaqGuard: CanActivateFn = () => {
  const platform = inject(PLATFORM_ID);

  const faqService = inject(FaqService);

  if (isPlatformBrowser(platform)) {
    return true;
  }

  return from(faqService.initFAQsInServer()).pipe(map(() => true));
};
